import React from 'react';
import { HeaderContext } from '../contexts/header-context';
export function useUfbModels() {
  const context = React.useContext(HeaderContext);
  if (!(context !== null && context !== void 0 && context.customCategoriesModel)) {
    throw new Error('customCategoriesModel is not set in HeaderContext');
  }
  if (!(context !== null && context !== void 0 && context.learningPathsMenuModel)) {
    throw new Error('learningPathsMenuModel is not set in HeaderContext');
  }
  return {
    customCategoriesModel: context.customCategoriesModel,
    learningPathsMenuModel: context.learningPathsMenuModel
  };
}
//# sourceMappingURL=use-ufb-models.js.map